import { render, staticRenderFns } from "./ResultingSender.vue?vue&type=template&id=7dd0b2cc"
import script from "./ResultingSender.vue?vue&type=script&lang=js"
export * from "./ResultingSender.vue?vue&type=script&lang=js"
import style0 from "./ResultingSender.vue?vue&type=style&index=0&id=7dd0b2cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports